import veciSearcherTabsStyles from "./styles/veci.js";
const searcherTabsThemes = {
    veci: veciSearcherTabsStyles
};
export default searcherTabsThemes;

//# sourceMappingURL=index.js.map